import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const CATEGORY_LABELS = {
  "buyer-guide": "Buyer's Guide",
  "buying-guide": "Buying Guide",
  "educational": "Learn",
};

const CATEGORY_COLORS = {
  "buyer-guide": "bg-accent/15 text-foreground border-accent/30",
  "buying-guide": "bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-950/30 dark:text-blue-300",
  "educational": "bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-950/30 dark:text-emerald-300",
};

export default function ArticleCard({ article, compact = false }) {
  return (
    <Link
      to={`/solar-guides/${article.slug}`}
      className="group block bg-card border border-border rounded-2xl p-5 hover:border-accent/40 hover:shadow-lg transition-all duration-200 hover:-translate-y-0.5"
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <Badge
          variant="outline"
          className={`text-[10px] font-mono uppercase tracking-wider shrink-0 ${CATEGORY_COLORS[article.category] || CATEGORY_COLORS["educational"]}`}
        >
          {CATEGORY_LABELS[article.category] || article.category}
        </Badge>
        <BookOpen className="w-4 h-4 text-muted-foreground shrink-0 mt-0.5 group-hover:text-accent transition-colors" />
      </div>

      <h3 className={`font-heading font-semibold group-hover:text-accent transition-colors mb-2 leading-snug ${compact ? "text-sm" : "text-base"}`}>
        {article.title}
      </h3>

      {!compact && (
        <p className="text-sm text-muted-foreground line-clamp-2 leading-relaxed mb-3">
          {article.metaDescription}
        </p>
      )}

      {article.tags?.length > 0 && !compact && (
        <div className="flex flex-wrap gap-1.5 mb-3">
          {article.tags.slice(0, 4).map((tag) => (
            <span key={tag} className="text-[10px] font-mono bg-secondary px-2 py-0.5 rounded text-muted-foreground">
              {tag}
            </span>
          ))}
        </div>
      )}

      <div className="flex items-center gap-1 text-xs font-mono text-accent">
        Read guide <ArrowRight className="w-3 h-3" />
      </div>
    </Link>
  );
}